import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router';
import './index.css';
//Import app and templates composants
import Home from './pages/Home';
import Message from './pages/Message';
import Delivery from './pages/Delivery';
import Confirmation from './pages/Confirmation';
import Validation from './pages/Validation';
import Historic from './pages/Historic';
//Import serviceWorkerRegistration for PWA
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// index.js or App.js
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'bootbox';
import $ from 'jquery';
import './pages/conf/i18n';
import { writeLogMsg } from './pages/conf/log';

/* =====================================================================================
   GLOBAL BACK BUTTON INTERCEPTOR (Android + WebView + Browser + PWA)
   ===================================================================================== */

window.__BACK_POPUP_OPEN__ = false; // Global flag

const setupBackInterceptor = (() => {
  let installed = false;

  return () => {
    if (installed) return;
    installed = true;

    const trapState = () => {
      // On pousse dans l'historique pour absorber les pressions back
      window.history.pushState({ trap: true }, "");
    };

    // Piège initial
    trapState();

    // Interception absolue du back
    window.addEventListener("popstate", (e) => {
      // Empêche toute navigation
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      // Une popup back est ouverte → on **bloque tout**
      if (window.__BACK_POPUP_OPEN__) {
        trapState(); // On retend le piège immédiatement
        return;
      }

      // Sinon, comportement normal : on renvoie un event interne
      trapState();
      window.dispatchEvent(new Event("app-back"));
    });
  };
})();

setupBackInterceptor();


/* =====================================================================================
   IMPORTANT : Réapplique le piège après CHAQUE navigation React Router
   (Sans ça, le back physique revient après changement de page)
   ===================================================================================== */

function NavigationBackTrap() {
    const location = useLocation();

    React.useEffect(() => {
        // Réinstalle le piège après chaque navigation
        window.history.pushState({ trap: true }, "");
    }, [location]);

    return null;
}

/* ===================================================================================== */

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <NavigationBackTrap />
    <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="/Delivery" element={<Delivery />} />
      <Route path="/Confirmation" element={<Confirmation />} />
      <Route path='/Validation' element={<Validation />} />
      <Route path='/Historic' element={<Historic />} />
      {/* Redirect all unknown routes to home */}
      <Route path="*" element={<Navigate to="/" />}/>
    </Routes>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    writeLogMsg('[SW] New content available. Activating and reloading...');
    if (registration && registration.waiting) {
      // Tell the waiting service worker to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });

      // Reload once the new service worker takes control
      registration.waiting.addEventListener('statechange', (event) => {
        if (event.target.state === 'activated') {
          writeLogMsg('[SW] New service worker activated — reloading page...');
          window.location.reload();
        }
      });
    }
  },
  onSuccess: () => {
    writeLogMsg('[SW] Service worker installed successfully — ready for offline use.');
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

(function() {
  if (!$.fn.modal || !$.fn.modal.Constructor) return;

  const Modal = $.fn.modal.Constructor;
  const oldHide = Modal.prototype.hide;

  Modal.prototype.hide = function(...args) {
    // Ensure NO element retains focus inside the modal before hiding
    try {
      const active = document.activeElement;
      if (active && this._element && this._element.contains(active)) {
        active.blur();
        document.body.focus();
      }
    } catch (e) {}

    // Delay aria-hidden toggle until focus is cleared
    setTimeout(() => oldHide.apply(this, args), 0);
  };
})();